export default __webpack_public_path__ + "static/media/img_pdf_4_axiom.fc414c48.png";